/* eslint-env browser */

(function (window, document) {
    var btn = document.querySelector('.load-more-btn');
    if (!btn) return;

    var feedElement = document.querySelector('.post-feed');
    if (!feedElement) return;

    var loading = false;

    btn.addEventListener('click', function () {
        if (loading) return;

        var nextUrl = btn.dataset.url;
        if (!nextUrl) return;

        loading = true;
        btn.textContent = '…';
        btn.style.opacity = '0.6';

        var xhr = new window.XMLHttpRequest();
        xhr.responseType = 'document';

        xhr.addEventListener('load', function () {
            var cards = this.response.querySelectorAll('article.post-card');

            cards.forEach(function (item) {
                var node = document.importNode(item, true);
                node.style.opacity = '0';
                node.style.transition = 'opacity 0.5s ease';
                feedElement.appendChild(node);
                window.requestAnimationFrame(function () {
                    window.requestAnimationFrame(function () {
                        node.style.opacity = '1';
                    });
                });
            });

            var nextBtn = this.response.querySelector('.load-more-btn');
            if (nextBtn && nextBtn.dataset.url) {
                btn.dataset.url = nextBtn.dataset.url;
                btn.textContent = 'Weitere Impulse';
                btn.style.opacity = '1';
            } else {
                btn.textContent = 'Keine weiteren Impulse';
                btn.style.opacity = '0.4';
                btn.style.cursor = 'default';
                btn.style.pointerEvents = 'none';
            }

            loading = false;
        });

        xhr.open('GET', nextUrl);
        xhr.send(null);
    });
})(window, document);
